import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getMediaTypes() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/media/v1/getMediaTypes`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        getFolders(){
            return new Promise((resolve, reject) => {
              axios
                .get('/files/v1/folder/getFolders')
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        addMedia(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/media/v1/addMedia`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateMedia(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/media/v1/updateMedia/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        getMediaGalleries(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/media/v1/getMedia`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/media/v1/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },

        deleteMedia(ctx, id){
            return new Promise((resolve, reject) => {
              axios
                .delete(`/media/v1/deleteMedia/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}